import { convertUnit } from '@heathmont/money';

const convertBtcUnit = (amount: number, from: string, to: string) =>
  convertUnit(amount, 'BTC', from, to);

export default convertBtcUnit;
